import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73 2.736a7.369 7.369 0 0 1 2.554-1.664A1.12 1.12 0 0 1 4.694 1c.334 0 1.086.173 1.28.706.329.908.74 2.093 1.04 3.226.088.329 0 1.128-.462 1.423l-1.016.644a.496.496 0 0 0 .115.313A14.75 14.75 0 0 0 7.057 8.96c.51.505 1.055.97 1.634 1.394.153.112.275.119.315.116l.646-1.02c.302-.476 1.066-.491 1.152-.491.082 0 .163.008.243.025 1.395.312 2.228.58 3.295 1.064.494.223.807 1.115.587 1.675a7.331 7.331 0 0 1-1.66 2.55c-.206.205-.601.709-.834.717-.234.01-.42.01-.42.01-2.675 0-5.442-1.232-7.59-3.38l-.044-.046C2.159 9.334.942 6.51 1.006 3.784c0 0-.052-.142.143-.388.181-.23.375-.451.581-.66Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Phone16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var Phone16 = createIcon(IconComponent);